import { AxiosInstance, AxiosResponse } from 'axios';
import BaseAPI from '../base/api';
import { ApiResponseDTO } from '../../dto/api';

class ConstellationDinnersApi extends BaseAPI {
  private paths = {
    GET_ATTENDEE_ID: (userId) => `ConstellationDinner/GetAttendeeId?userId=${userId}`,
    GET_CONSTELLATION_DINNER_FORM: (attendeeId) =>
      `ConstellationDinner/GetConstellationDinnerForm?attendeeId=${attendeeId}`,
    SUBMIT_CONSTELLATION_DINNER_FORM: (attendeeId) =>
      `ConstellationDinner/SubmitConstellationDinnerForm?attendeeId=${attendeeId}`,
  };

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(axios: AxiosInstance, backend: string) {
    super(axios, backend);
  }

  async getAttendeeID(userId: string) {
    return this.axios.get<ApiResponseDTO>(this.paths.GET_ATTENDEE_ID(userId));
  }

  async getConstellationDinnerForm(attendeeId: string) {
    return this.axios.get<ApiResponseDTO>(this.paths.GET_CONSTELLATION_DINNER_FORM(attendeeId));
  }

  async submitConstellationDinnerForm(attendeeId: string, data: {}) {
    return this.axios.post<ApiResponseDTO>(this.paths.SUBMIT_CONSTELLATION_DINNER_FORM(attendeeId), data);
  }
}

export default ConstellationDinnersApi;
